import React, { useState } from 'react';
import IconMap from '../ui/icons/IconMap';
import SearchModal from './SearchModal';
import SearchMapData from './SearchMapData';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

const SearchMapMobile = () => {
	const api = useInstantSearch();
	const [ isOpen, setIsOpen ] = useState( false );
	const handleClose = () => {
		setIsOpen( false );
	};
	return (
		<>
			<button
				type="button"
				aria-label="Open map"
				disabled={api.results.hits.length === 0}
				className={`btn-tiny btn-tiny--platinum`}
				onClick={() => {
					setIsOpen( true );
				}}
			>
				<IconMap />
				<span className='tw-whitespace-nowrap'>
					View Map
				</span>
			</button>
			{isOpen && (
				<SearchModal isShown={isOpen} onClose={handleClose} headerText={'Map View'}>
					<SearchMapData />
				</SearchModal>
			)}
		</>
	);
};

export default SearchMapMobile;
